"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRANT_FINDER_INTERNATIONAL_SCOPE = exports.GRANT_FINDER_NATIONWIDE_SCOPES = void 0;
exports.GRANT_FINDER_NATIONWIDE_SCOPES = ["national", "nationwide"];
exports.GRANT_FINDER_INTERNATIONAL_SCOPE = "international";
